import ProposalsStepsMixin from "./ProposalsStepsMixin";
import ProductsMixin from "./ProductsMixin";
import LocationsMixin from "./LocationsMixin";
import ContactsMixin from "./ContactsMixin";
import CampaignsMixin from "./CampaignsMixin";
import CampaignFieldsMixin from "./CampaignFieldsMixin";
import ProposalConflictHandlingMixin from "./errors/ProposalConflictHandlingMixin";
import HttpErrorMixin from "./HttpErrorMixin";
import {message} from '@grininc/grin-ui'

export default {
    mixins: [ //@TODO: move mixins set to specific provider definition
        ProductsMixin,
        ProposalsStepsMixin,
        LocationsMixin,
        ContactsMixin,
        CampaignsMixin,
        CampaignFieldsMixin,
        ProposalConflictHandlingMixin,
        HttpErrorMixin
    ],
    data() {
        return {
            errorMessage: null,
            errors: {},
            isLoading: false,
        }
    },
    props: {
        tag: {
            type: String,
            default: 'div',
        }
    },
    methods: {
        handleHttpError(error, type = 'step') {
            if(error.message === 'Expired Proposal') {
                return this.handleExpiredProposalError();
            }
            else if (error.status === 422) {
                this.errors = error.data.errors;
                this.errorMessage = error.data.message;
            } else if (error.status === 409) {
                if (type === 'step') {
                    return this.updateStep(error.data);
                } else if (type === 'proposal') {
                    this.handleConflictError(error);
                } else {
                    return this.handleGenericError();
                }
            } else if(error.status === 423) {
                return this.handleLockedException(error.data);
            } else {
                return this.handleGenericError();
            }
        },
        handleExpiredProposalError() {
            return this.$http.delete(`/api/v1/contacts/${this.contactId}/campaigns/${this.campaignId}/proposals/${this.proposalId}`)
                .then(() => {
                    this.$router.push({name: 'v2.campaign'});
                    message.info('Your in-progress proposal has expired. Please start again. You have 24 hours to complete.')
                });
        },
        handleGenericError() {
            message.error('Something went wrong, please try again or contact support');
        },

        resetErrors() {
            this.errorMessage = null;
            this.errors = {};
        },
    }
}
